// Tests page
import checkAnswers from './sync/pages/tests/check-answers';
import sendCommentToDB from './async/components/volunteers/send-comment-to-DB';

// Volunteers page

export { checkAnswers, sendCommentToDB };
